// GÉNÉRÉ par `pnpm blueprint apply` à partir de blueprint.json — ne pas modifier à la main.
import type { WebModule } from "../core/modules";
import xCandidats from "./x-candidats/index";
import xDocuments from "./x-documents/index";
import xExtraction from "./x-extraction/index";
import xAvocats from "./x-avocats/index";
import xNotifications from "./x-notifications/index";

export const MODULES: WebModule[] = [xCandidats, xDocuments, xExtraction, xAvocats, xNotifications];
